import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    button: ['shop now - button'],
    left_button: ['never show - button'],
    right_button: ['close - button']
  }
};

const ListModalTracking: FC = () => {
  const text = useSelector((state: any) => state.editText.text);
  const tracking = useSelector((state: any) => state.trackings.tracking);

  const style = `
.root_tracking {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;
    
    .center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 2rem;
    }
    .modal_wrapper {
      width: 100%;
      padding: 2rem 0;

      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .title {
      height: 3rem;
      display: flex;
      align-items: center;
    }
    .title_inner {
      width: 100%;
      height: auto;
      max-height: 3rem;
    }

    .middle_wrapper {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .middle_text_wrapper {
      height: 4rem;
      display: flex;
      align-items: center;
      overflow: hidden;
    }
    .middle_text_wrapper .middle_number {
      max-width: 3rem;
      min-width: 3rem;
      max-height: 3rem;
      min-height: 3rem;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1.25rem;
      font-weight: 700;
    }
    .middle_text_wrapper .middle_text {
      height: 4rem;
      display: flex;
      align-items: center;
    }
    .middle_text_inner {
      height: auto;
      max-height: 4rem;
    }

    .btn_wrapper {
      width: 100%;
      height: 3rem;
    }

    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper {
        height: 1.25rem;
    }
    .bottom_wrapper .style01 {
        width: 100%;
        height: 2.5rem;
    }
    .bottom_wrapper .style02 {
        width: 100%;
        height: 2.5rem;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
    }
}
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="center">
          <div className="modal_wrapper">
            <div className="title" />
            <div className="middle_wrapper">
              {text?.multi_text?.map((text: string, idx: number) => (
                <div key={idx} className="middle_text_wrapper">
                  <p className="middle_number" />
                  <p className="middle_text" />
                </div>
              ))}
            </div>
            <div className="btn_wrapper tracking_center">
              <EditTracking value={tracking?.button?.[0]} type="button" />
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01 tracking_center">
              <EditTracking
                value={tracking?.left_button?.[0]}
                type="left_button"
              />
            </span>
            <span className="style02 tracking_center">
              <EditTracking
                value={tracking?.right_button?.[0]}
                type="right_button"
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default ListModalTracking;
